"use client";

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Simplify } from "@/prismicio-types";
import { Content } from "@prismicio/client";
import React from "react";
import HelplineCard from "./helpline-card";

type Props = {
  data: Simplify<Content.CharitiesHelplinesSliceDefaultPrimary>;
};

export default function AccordionSection({ data }: Props) {
  const categoriesWithHelplines = data.categories.map((category) => ({
    ...category,
    helplines: data.helplines.filter(
      (helpline) => helpline.category_slug === category.slug
    ),
  }));

  return (
    <Accordion
      type="single"
      collapsible
      className="w-full grid grid-cols-1 xl:grid-cols-2 gap-4"
    >
      {categoriesWithHelplines.map((category, index) => (
        <AccordionItem
          value={String(index)}
          className="border-none space-y-4"
          key={index}
        >
          <AccordionTrigger className="text-start bg-[#EBF7FF] px-4 text-xl rounded-full font-merriweather text-primary [&>svg]:size-8 [&>svg]:bg-[#9CD6FA] [&>svg]:rounded-full [&>svg]:p-2 [&>svg]:-rotate-90 [&[data-state=open]>svg]:rotate-0">
            {category.title}
          </AccordionTrigger>
          <AccordionContent className="grid md:grid-cols-2 grid-cols-1 gap-4 text-balance">
            {category.helplines.map((item, index) => (
              <HelplineCard key={index} data={item} />
            ))}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
